import { LoadSchedule } from "./schedule";

export interface GetLoadsResponse {
  loads: LoadSchedule[];
}
